export default "__VITE_ASSET__Cmq8nKqB__"